export default __webpack_public_path__ + "static/media/Dados.fd0761fa.mp3";